<footer class="px-container pt-[5%] pb-[20%] lg:pb-[50%]">
    <div class="links">
        <!-- <div class="flex flex-col gap-4">
            <p class="font-semibold">Partner e Radio ufficiale</p>
            <img src="../../../assets/images/home/radio-manila.png" alt="Radio manila" class="w-52">
        </div> -->
        <div class="flex lg:flex-row flex-col items-start gap-4">
            <!-- <img src="../../../assets/images/IT_FundedbytheEU_RGB_POS.png" alt="Finanziato dall'Unione Europea" class="w-52"> -->
            <img src="../../../assets/images/IT_Finanziato_dall_Unione_europea_RGB_MONOCHROME.png" alt="Finanziato dall'Unione Europea" class="h-16">
            <img src="../../../assets/images/logo_mdc.svg" alt="Ministero della Cultura" class="h-16">
        </div>
        <ul class="flex flex-col gap-4 mt-8 font-semibold text-lg">
            <li><a class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" routerLink="/">home</a></li>
            <li><a class="nav-link" routerLinkActive="active" routerLink="/stagione">stagione</a></li>
            <li><a class="nav-link" href="https://teatrocolosseo.eventim-inhouse.de/" target="_blank">biglietti</a></li>
            <li><a class="nav-link" routerLinkActive="active" routerLink="/info">info</a></li>
            <li *ngIf="carnetAttivo"><a class="nav-link" routerLinkActive="active" routerLink="/carnet">carnet</a></li>
            <li><a class="nav-link" routerLinkActive="active" routerLink="/news">news</a></li>
            <li><a class="nav-link" routerLinkActive="active" routerLink="/contatti">contatti</a></li>
            <li><a class="nav-link" href="https://archivio.teatrocolosseo.it" target="_blank">archivio</a></li>
        </ul>
        <div class="flex gap-4 mt-8 w-full text-2xl">
            <a href="https://www.instagram.com/teatrocolosseo/" target="_blank">
                <i class="hover:text-accent transition-all duration-300 bi bi-instagram"></i>
            </a>
            <a href="https://twitter.com/teatrocolosseo" target="_blank">
                <i class="hover:text-accent transition-all duration-300 bi bi-twitter"></i>
            </a>
            <a href="https://www.facebook.com/teatro.colosseo/" target="_blank">
                <i class="hover:text-accent transition-all duration-300 bi bi-facebook"></i>
            </a>
            <a href="https://www.youtube.com/@teatrocolosseotorino1982" target="_blank">
                <i class="hover:text-accent transition-all duration-300 bi bi-youtube"></i>
            </a>
        </div>
    </div>
    <div class="w-full lg:w-[30vw] newsletter">
            <h1 *ngIf="!newsletter" class="text-2xl">Tieniti informato, <br /> iscriviti alla newsletter</h1>
            <h1 *ngIf="newsletter" class="text-2xl">{{newsletter}}</h1>
        <form class="flex flex-col gap-8 w-full" [formGroup]="formNewsLetter" (ngSubmit)="onSubmit()">
            <input class="w-full font-mono input-minimal" type="email" placeholder="la tua mail" formControlName="email">
            <button type="submit" class="w-fit font-medium btn btn-outln btn-sm">Invia</button>
        </form>
        <span class="text-sm">
            Via Madama Cristina, 71 - 10125 Torino // T 011 6698034 - 011 6505195 <br> 
            ©1998 - {{anno}} TeatroColosseo S.r.l. P.Iva 04092480013 <br> 
            <span class="block mt-4">
                <a routerLink="/privacy" class="hover:underline">Privacy Policy</a> | 
                <a routerLink="amministrazione-trasparente" class="hover:underline">Amministrazione Trasparente</a> | 
                <a routerLink="/condizioni" class="hover:underline">Condizioni generali di contratto</a>
            </span> 
        </span>
    </div>
</footer>